import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/amj/solution_back.png";

function solutionamj() {
  return (
    <section
      className="solution_amj p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>Tekrevol’s Solution</h2>
            <p>
              We performed a meticulous research of the target market, projected
              users, and the overall scope of the project. Our creative and
              development teams devised a strategic plan and developed the
              fitness app, Workplace Wellness that we are proud of today.
            </p>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/amj/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={690}
              height={664}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default solutionamj;
